<template>
	<ModalLayout title="Deposit" back>
		<section class="deposit section--mini section screen-start">
			<p class="deposit__title">Recieve USDT</p>
			<div class="deposit__qr" v-html="qr"></div>
			<p class="deposit__hint">The commission is charged from the deposit. We charge a 8 usdt + 9% fee on deposit.</p>
			<p class="deposit__address">{{ me.wallet }}</p>
			<div class="deposit__footer">
				<Button color="dark" type="button" @click="copyWallet">
					<Icon name="copy" :size="1.1" /> Copy
				</Button>
				<Button color="brand" @click="scan">
					<Icon name="check" :size="1.5" /> Paid
				</Button>
			</div>
		</section>
	</ModalLayout>
</template>
<script lang="ts" setup>
import "./TopUpView.scss";
import Button from "@/components/Button/Button.vue";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import ModalLayout from "@/layouts/ModalLayout/ModalLayout.vue";
import {computed, onMounted, ref} from "vue";
import Icon from "@/components/Icon/Icon.vue";
import {useApiStore} from "@/stores/apiStore";
import {storeToRefs} from "pinia";
import {useUserStore} from "@/stores/userStore";
import {useAlertsStore} from "@/stores/alertsStore";
import copy from "copy-to-clipboard";
import {useRouter} from "vue-router";

let router = useRouter();

let {api} = useApiStore();
let userStore = useUserStore();
let alertsStore = useAlertsStore();

let {me} = storeToRefs(userStore);

let qr = ref<string|null>(null);

function copyWallet(){
	copy(me.value!.wallet);

	alertsStore.pushSuccess('Was copied to clipboard!');
}

async function scan(){

	router.back();

	await api.scanDeposits();

	alertsStore.pushSuccess('Wait 5 minutes for scan your deposit');

}

onMounted(async () => {

	qr.value = await api.getDepositQr();

});

</script>